import { defineLocale } from "../composables/defineLocale.js";
export default defineLocale({
  name: "\u0420\u0443\u0441\u0441\u043A\u0438\u0439",
  code: "ru",
  messages: {
    alert: {
      close: "\u0417\u0430\u043A\u0440\u044B\u0442\u044C"
    },
    authForm: {
      hidePassword: "\u0421\u043A\u0440\u044B\u0442\u044C \u043F\u0430\u0440\u043E\u043B\u044C",
      showPassword: "\u041F\u043E\u043A\u0430\u0437\u0430\u0442\u044C \u043F\u0430\u0440\u043E\u043B\u044C",
      submit: "\u041F\u0440\u043E\u0434\u043E\u043B\u0436\u0438\u0442\u044C"
    },
    banner: {
      close: "\u0417\u0430\u043A\u0440\u044B\u0442\u044C"
    },
    calendar: {
      nextMonth: "\u0421\u043B\u0435\u0434\u0443\u044E\u0449\u0438\u0439 \u043C\u0435\u0441\u044F\u0446",
      nextYear: "\u0421\u043B\u0435\u0434\u0443\u044E\u0449\u0438\u0439 \u0433\u043E\u0434",
      prevMonth: "\u041F\u0440\u0435\u0434\u044B\u0434\u0443\u0449\u0438\u0439 \u043C\u0435\u0441\u044F\u0446",
      prevYear: "\u041F\u0440\u0435\u0434\u044B\u0434\u0443\u0449\u0438\u0439 \u0433\u043E\u0434"
    },
    carousel: {
      dots: "\u0412\u044B\u0431\u0435\u0440\u0438\u0442\u0435 \u0441\u043B\u0430\u0439\u0434 \u0434\u043B\u044F \u043E\u0442\u043E\u0431\u0440\u0430\u0436\u0435\u043D\u0438\u044F",
      goto: "\u041F\u0435\u0440\u0435\u0439\u0442\u0438 \u043A {slide}",
      next: "\u0414\u0430\u043B\u0435\u0435",
      prev: "\u041D\u0430\u0437\u0430\u0434"
    },
    chatPrompt: {
      placeholder: "\u0412\u0432\u0435\u0434\u0438\u0442\u0435 \u0432\u0430\u0448\u0435 \u0441\u043E\u043E\u0431\u0449\u0435\u043D\u0438\u0435 \u0437\u0434\u0435\u0441\u044C..."
    },
    chatPromptSubmit: {
      label: "\u041E\u0442\u043F\u0440\u0430\u0432\u0438\u0442\u044C"
    },
    colorMode: {
      dark: "\u0422\u0451\u043C\u043D\u0430\u044F",
      light: "\u0421\u0432\u0435\u0442\u043B\u0430\u044F",
      switchToDark: "\u041F\u0435\u0440\u0435\u043A\u043B\u044E\u0447\u0438\u0442\u044C\u0441\u044F \u043D\u0430 \u0442\u0451\u043C\u043D\u044B\u0439 \u0440\u0435\u0436\u0438\u043C",
      switchToLight: "\u041F\u0435\u0440\u0435\u043A\u043B\u044E\u0447\u0438\u0442\u044C\u0441\u044F \u043D\u0430 \u0441\u0432\u0435\u0442\u043B\u044B\u0439 \u0440\u0435\u0436\u0438\u043C",
      system: "\u0421\u0438\u0441\u0442\u0435\u043C\u043D\u0430\u044F"
    },
    commandPalette: {
      back: "\u041D\u0430\u0437\u0430\u0434",
      close: "\u0417\u0430\u043A\u0440\u044B\u0442\u044C",
      noData: "\u041D\u0435\u0442 \u0434\u0430\u043D\u043D\u044B\u0445",
      noMatch: "\u0421\u043E\u0432\u043F\u0430\u0434\u0435\u043D\u0438\u0439 \u043D\u0435 \u043D\u0430\u0439\u0434\u0435\u043D\u043E",
      placeholder: "\u0412\u0432\u0435\u0434\u0438\u0442\u0435 \u043A\u043E\u043C\u0430\u043D\u0434\u0443 \u0438\u043B\u0438 \u0432\u044B\u043F\u043E\u043B\u043D\u0438\u0442\u0435 \u043F\u043E\u0438\u0441\u043A..."
    },
    contentSearch: {
      links: "\u0421\u0441\u044B\u043B\u043A\u0438",
      theme: "\u0422\u0435\u043C\u0430"
    },
    contentSearchButton: {
      label: "\u041F\u043E\u0438\u0441\u043A..."
    },
    contentToc: {
      title: "\u041D\u0430 \u044D\u0442\u043E\u0439 \u0441\u0442\u0440\u0430\u043D\u0438\u0446\u0435"
    },
    dashboardSearch: {
      theme: "\u0422\u0435\u043C\u0430"
    },
    dashboardSearchButton: {
      label: "\u041F\u043E\u0438\u0441\u043A..."
    },
    dashboardSidebarCollapse: {
      collapse: "\u0421\u0432\u0435\u0440\u043D\u0443\u0442\u044C \u0431\u043E\u043A\u043E\u0432\u0443\u044E \u043F\u0430\u043D\u0435\u043B\u044C",
      expand: "\u0420\u0430\u0437\u0432\u0435\u0440\u043D\u0443\u0442\u044C \u0431\u043E\u043A\u043E\u0432\u0443\u044E \u043F\u0430\u043D\u0435\u043B\u044C"
    },
    dashboardSidebarToggle: {
      close: "\u0417\u0430\u043A\u0440\u044B\u0442\u044C \u0431\u043E\u043A\u043E\u0432\u0443\u044E \u043F\u0430\u043D\u0435\u043B\u044C",
      open: "\u041E\u0442\u043A\u0440\u044B\u0442\u044C \u0431\u043E\u043A\u043E\u0432\u0443\u044E \u043F\u0430\u043D\u0435\u043B\u044C"
    },
    error: {
      clear: "\u0412\u0435\u0440\u043D\u0443\u0442\u044C\u0441\u044F \u043D\u0430 \u0433\u043B\u0430\u0432\u043D\u0443\u044E"
    },
    fileUpload: {
      removeFile: "\u0423\u0434\u0430\u043B\u0438\u0442\u044C {filename}"
    },
    header: {
      close: "\u0417\u0430\u043A\u0440\u044B\u0442\u044C \u043C\u0435\u043D\u044E",
      open: "\u041E\u0442\u043A\u0440\u044B\u0442\u044C \u043C\u0435\u043D\u044E"
    },
    inputMenu: {
      create: '\u0421\u043E\u0437\u0434\u0430\u0442\u044C "{label}"',
      noData: "\u041D\u0435\u0442 \u0434\u0430\u043D\u043D\u044B\u0445",
      noMatch: "\u0421\u043E\u0432\u043F\u0430\u0434\u0435\u043D\u0438\u0439 \u043D\u0435 \u043D\u0430\u0439\u0434\u0435\u043D\u043E"
    },
    inputNumber: {
      decrement: "\u0423\u043C\u0435\u043D\u044C\u0448\u0438\u0442\u044C",
      increment: "\u0423\u0432\u0435\u043B\u0438\u0447\u0438\u0442\u044C"
    },
    modal: {
      close: "\u0417\u0430\u043A\u0440\u044B\u0442\u044C"
    },
    pricingTable: {
      caption: "\u0421\u0440\u0430\u0432\u043D\u0435\u043D\u0438\u0435 \u0446\u0435\u043D\u043D\u044B\u0445 \u043F\u043B\u0430\u043D\u043E\u0432"
    },
    prose: {
      codeCollapse: {
        closeText: "\u0421\u0432\u0435\u0440\u043D\u0443\u0442\u044C",
        name: "\u043A\u043E\u0434",
        openText: "\u0420\u0430\u0437\u0432\u0435\u0440\u043D\u0443\u0442\u044C"
      },
      collapsible: {
        closeText: "\u0421\u043A\u0440\u044B\u0442\u044C",
        name: "\u0441\u0432\u043E\u0439\u0441\u0442\u0432\u0430",
        openText: "\u041F\u043E\u043A\u0430\u0437\u0430\u0442\u044C"
      },
      pre: {
        copy: "\u0421\u043A\u043E\u043F\u0438\u0440\u043E\u0432\u0430\u0442\u044C \u043A\u043E\u0434 \u0432 \u0431\u0443\u0444\u0435\u0440 \u043E\u0431\u043C\u0435\u043D\u0430"
      }
    },
    selectMenu: {
      create: '\u0421\u043E\u0437\u0434\u0430\u0442\u044C "{label}"',
      noData: "\u041D\u0435\u0442 \u0434\u0430\u043D\u043D\u044B\u0445",
      noMatch: "\u0421\u043E\u0432\u043F\u0430\u0434\u0435\u043D\u0438\u0439 \u043D\u0435 \u043D\u0430\u0439\u0434\u0435\u043D\u043E",
      search: "\u041F\u043E\u0438\u0441\u043A..."
    },
    slideover: {
      close: "\u0417\u0430\u043A\u0440\u044B\u0442\u044C"
    },
    table: {
      noData: "\u041D\u0435\u0442 \u0434\u0430\u043D\u043D\u044B\u0445"
    },
    toast: {
      close: "\u0417\u0430\u043A\u0440\u044B\u0442\u044C"
    }
  }
});
